import { useMemo } from "react";
import type { Category, Entry } from "@/types";

export function useExpenseSummary(entries: Entry[], categories: Category[]) {
  return useMemo(() => {
    let totalExpenses = 0;
    let totalGains = 0;
    for (const e of entries) {
      const a = Number(e.amount);
      if ((e.kind ?? "expense") === "gain") totalGains += a;
      else totalExpenses += a;
    }
    const net = Math.round((totalGains - totalExpenses) * 100) / 100;
    const subcategoryCount = categories.reduce(
      (acc, category) => acc + (category.subcategories?.length ?? 0),
      0,
    );

    return {
      totalExpenses: Math.round(totalExpenses * 100) / 100,
      totalGains: Math.round(totalGains * 100) / 100,
      net,
      entryCount: entries.length,
      categoryCount: categories.length,
      subcategoryCount,
    };
  }, [entries, categories]);
}
